import Card from "../../components/shared-card/card";
import styles from "./login.module.scss";
import TaylorFarms from "../../assets/TaylorFarms.png";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import Mojo from "../../assets/Mojo.png";

function Login() {
  const { instance } = useMsal();
  const heading = "MOJO";

  const handleLogin = (loginType) => {
    if (loginType === "popup") {
      instance.loginPopup(loginRequest).catch((e) => {
        console.log(e);
      });
    } else if (loginType === "redirect") {
      instance.loginRedirect(loginRequest).catch((e) => {
        console.log(e);
      });
    }
  };

  return (
    <div className={styles.loginContainer}>
      <Card>
        <div className={styles.loginSubContainer}>
          <div className="grid" style={{ alignItems: "center" }}>
            <div className={`col-12 ${styles.loginLogoContainer}`} style={{ textAlign: "center" }}>
              <img
                src={TaylorFarms}
                alt="Taylor Farms"
                className={styles.brandLogo}
              />
               <div>
               <img
                src={Mojo}
                alt="MOJO"
                className={styles.mojoBrandLogo}
              />
              </div>
            </div>
            <div className="col-12" style={{ textAlign: "center" }}>
              {/* <h2 className={`${styles.brandName}`}>{heading}</h2> */}
              {/* <img
                src={Mojo}
                alt="MOJO"
                className={styles.brandLogo}
              /> */}
            </div>
          </div>
          <div className={`grid ${styles.loginContainerBox}`}>
            <div className={`col-12 ${styles.heading} ${styles.title}`}>
              Log In
            </div>
            <div className={`col-12 ${styles.subHeading} ${styles.title}`}>
              to continue with Taylor Farms account
            </div>
            <div className={`col-12 ${styles.btnContainer}`}>
              <button
                className={styles.signInBtn}
                onClick={() => handleLogin("redirect")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="26"
                  viewBox="0 0 204 205"
                  fill="none"
                >
                  <g clipPath="url(#clip0_1981_94561)">
                    <path
                      d="M101.881 0.0224609C102.099 0.0224609 102.317 0.294076 102.643 0.782988C102.916 1.21758 125.849 28.651 153.63 61.7341C181.411 94.8172 204.071 122.033 203.963 122.196C203.908 122.359 181.792 140.449 154.828 162.341C127.864 184.234 104.931 202.867 103.896 203.736C102.099 205.203 101.99 205.257 101.336 204.605C100.955 204.225 77.9673 185.483 50.2408 162.939C22.5142 140.395 -0.0919516 121.816 0.0169937 121.544C0.125939 121.273 22.8955 94.1653 50.731 61.2452C78.5665 28.3251 101.336 1.10893 101.445 0.674343C101.554 0.239754 101.717 0.0224609 101.881 0.0224609Z"
                      fill="#00BEF2"
                    />
                    <path
                      d="M98.1217 172.391C94.9623 171.25 91.1492 167.991 89.5695 164.949C87.6085 161.2 87.7719 155.333 89.9508 150.662C91.6395 147.185 91.6395 147.076 90.55 146.261C89.9508 145.827 82.706 141.807 74.5351 137.407C66.3642 133.006 59.2283 129.149 58.738 128.878C58.0844 128.498 56.9949 128.878 55.0339 130.127C48.6606 134.147 42.0149 133.713 36.7856 128.878C33.0269 125.401 31.9375 122.956 31.9375 117.959C31.9375 113.124 32.918 110.625 36.0229 107.529C40.2173 103.346 45.828 101.933 51.2208 103.726C54.1623 104.704 54.2168 104.704 56.0689 103.291C58.2478 101.662 75.7335 85.7448 84.1767 77.7592L90.0053 72.2182L88.2622 68.5785C84.7215 61.2448 86.5191 53.0963 92.729 48.2072C96.1063 45.5453 98.612 44.7305 103.46 44.7305C114.79 44.7305 122.689 56.573 118.44 67.1661C117.296 70.0996 117.296 70.1539 118.386 71.9466C119.312 73.522 135.054 92.4809 143.388 102.151C144.859 103.835 146.493 105.193 147.038 105.193C147.583 105.193 149.435 104.649 151.178 103.998C159.294 100.792 167.847 104.378 171.224 112.418C173.403 117.578 171.496 124.532 166.866 128.715C163.598 131.648 161.201 132.572 156.843 132.572C153.793 132.572 152.649 132.246 149.435 130.507C147.038 129.204 145.186 128.552 144.423 128.769C143.116 129.095 123.016 142.839 118.549 146.424C115.825 148.652 115.607 149.466 117.024 152.78C118.386 156.04 118.222 161.146 116.697 164.351C115.008 167.882 110.814 171.413 107.164 172.5C103.46 173.532 101.227 173.532 98.1217 172.391ZM99.0478 112.526V81.5619L97.3047 79.1716C96.3241 77.8679 95.3981 76.7814 95.2347 76.7814C94.5265 76.7814 59.3372 108.669 59.3372 109.321C59.3372 109.484 59.882 111.114 60.5356 112.852C61.1893 114.645 61.6796 117.198 61.6251 118.665C61.5706 120.132 61.5706 121.761 61.5706 122.305C61.6251 123.554 73.3912 131.051 91.0403 141.209C95.8884 144.034 97.577 144.74 98.1762 144.251C98.8844 143.654 99.0478 137.624 99.0478 112.526ZM113.973 139.905C137.288 125.292 141.645 122.359 141.918 121.272C142.081 120.621 142.299 118.067 142.354 115.514L142.517 110.951L130.642 96.8812C117.895 81.8335 113.211 76.7271 112.121 76.7271C111.74 76.7271 109.833 77.8136 107.872 79.1173L104.277 81.5076L104.441 112.418C104.604 140.123 104.822 144.795 105.857 144.795C105.966 144.849 109.67 142.622 113.973 139.905Z"
                      fill="white"
                      stroke="white"
                      strokeWidth="8.18631"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1981_94561">
                      <rect width="204" height="205" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <span className={styles.signInBtnLabel}>Sign in</span>
              </button>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}

export default Login;
